import React, { Fragment } from 'react'
import Component from 'components/component'
import { DI } from 'modules'
import Spoiler from 'components/spoiler'
import TargetModal from './target-modal'
import {
  getURLHashParams,
  setURLHash,
  removeURLHash,
} from 'helpers/urlHashParams'

const defaultState = {
  facebook: '',
  youtube: '',
  periscope: '',
  vkontakte: '',
  custom_rtmp: '',
  srt: '',
  hls_full_hd: '',
}

const keys = ['fb', 'yt', 'ps', 'vk', 'rtmp720', 'srt', 'hls_full_hd', 'tvu']

class LiveTargets extends Component {
  state = {
    ...defaultState,
  }

  getStreamQuantity = () => {
    const streamsCount = {
      facebook: '',
      youtube: '',
      periscope: '',
      vkontakte: '',
      odnoklassniki: '',
      custom_rtmp: '',
      srt: '',
      hls_full_hd: '',
      tvu: '',
    }

    const streams =
      this.props.targets.list.getValue(this.props.liveEvent.slug).payload[
        this.props.selectedLanguageID
      ] || []

    streams.forEach(stream => {
      streamsCount[stream.target_type] = ++streamsCount[stream.target_type] || 1
    })
    return streamsCount
  }

  componentDidMount() {
    this.setState(this.getStreamQuantity())
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState(this.getStreamQuantity())
    }
  }

  getSpoilerTitle = target_type => {
    return this.state[target_type] ? ': ' + this.state[target_type] : ''
  }

  onModalChange = name => value => {
    if (value === true) {
      setURLHash(name, value, this.props.history)
    } else {
      removeURLHash(name, this.props.history)
    }
  }

  render() {
    const strings = this.props.common.strings
    const liveEvent = this.props.liveEvent
    const hasOpened = getURLHashParams(keys)

    const streamTo = [
      liveEvent.streamTo.enabledFacebook && (
        <TargetModal
          key="fb"
          id="fb"
          defaultOpen={hasOpened.fb}
          targetName="Facebook"
          onChange={this.onModalChange('fb')}
          spoilerTitle={`${strings['stream_to']} Facebook${this.getSpoilerTitle(
            'facebook'
          )}`}
          streamHelp={
            <FacebookStreamHelp strings={this.props.common.strings} />
          }
          instructions={<FacebookManual strings={this.props.common.strings} />}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'facebook',
          }}
        />
      ),
      liveEvent.streamTo.enabledYouTube && (
        <TargetModal
          key="yt"
          id="yt"
          defaultOpen={hasOpened.yt}
          targetName="YouTube"
          onChange={this.onModalChange('yt')}
          spoilerTitle={`${strings['stream_to']} YouTube${this.getSpoilerTitle(
            'youtube'
          )}`}
          streamHelp={<YouTubeStreamHelp strings={this.props.common.strings} />}
          instructions={<YouTubeManual strings={this.props.common.strings} />}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'youtube',
          }}
        />
      ),
      liveEvent.streamTo.enabledPeriscope && (
        <TargetModal
          key="ps"
          id="ps"
          defaultOpen={hasOpened.ps}
          targetName="Periscope"
          onChange={this.onModalChange('ps')}
          spoilerTitle={`${
            strings['stream_to']
          } Periscope${this.getSpoilerTitle('periscope')}`}
          streamHelp={
            <PeriscopeStreamHelp strings={this.props.common.strings} />
          }
          instructions={<PeriscopeManual strings={this.props.common.strings} />}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'periscope',
          }}
        />
      ),
      liveEvent.streamTo.enabledVkontakte && (
        <TargetModal
          key="vk"
          id="vk"
          defaultOpen={hasOpened.vk}
          targetName="Vkontakte"
          onChange={this.onModalChange('vk')}
          spoilerTitle={`${strings['stream_to']} VK${this.getSpoilerTitle(
            'vkontakte'
          )}`}
          streamHelp={
            <VkontakteStreamHelp strings={this.props.common.strings} />
          }
          instructions={<VkontakteManual strings={this.props.common.strings} />}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'vkontakte',
          }}
        />
      ),
      liveEvent.streamTo.enabledRTMP720 && (
        <TargetModal
          key="rtmp720"
          id="rtmp720"
          defaultOpen={hasOpened.rtmp720}
          targetName="RTMP 720p"
          onChange={this.onModalChange('rtmp720')}
          spoilerTitle={`RTMP 720p${this.getSpoilerTitle('custom_rtmp')}`}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'custom_rtmp',
            hdtv_format: '720p',
          }}
          custom
        />
      ),
      liveEvent.streamTo.enabledRTMP1080 && (
        <TargetModal
          key="rtmp1080"
          id="rtmp1080"
          defaultOpen={hasOpened.rtmp1080}
          targetName="RTMP 1080p"
          onChange={this.onModalChange('rtmp1080')}
          spoilerTitle={`RTMP 1080p${this.getSpoilerTitle('custom_rtmp')}`}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'custom_rtmp',
            hdtv_format: '1080p',
          }}
          custom
        />
      ),
      liveEvent.streamTo.enabledSRT && (
        <TargetModal
          key="srt"
          id="srt"
          defaultOpen={hasOpened.srt}
          targetName="SRT"
          onChange={this.onModalChange('srt')}
          spoilerTitle={`SRT${this.getSpoilerTitle('srt')}`}
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'srt',
          }}
        />
      ),
      liveEvent.streamTo.enabledHLSFullHd && (
        <TargetModal
          key="hls_dvr"
          id="hls_dvr"
          defaultOpen={hasOpened.hls_full_hd}
          targetName="HLS link"
          onChange={this.onModalChange('hls_full_hd')}
          spoilerTitle="HLS Link"
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'hls_dvr',
          }}
        />
      ),
      liveEvent.streamTo.enabledTVU && (
        <TargetModal
          key="tvu"
          id="tvu"
          defaultOpen={hasOpened.tvu}
          targetName="TVU"
          onChange={this.onModalChange('tvu')}
          spoilerTitle={`${strings['stream_to']} MY TVU${this.getSpoilerTitle(
            'tvu'
          )}`}
          streamHelp={<TVUStreamHelp strings={this.props.common.strings} />}
          instructions={
            <TVUManual
              strings={this.props.common.strings}
              languages={liveEvent.languages}
            />
          }
          liveEvent={this.props.liveEvent}
          selectedLanguageID={this.props.selectedLanguageID}
          targetParams={{
            target_type: 'tvu',
          }}
        />
      ),
    ].filter(Boolean)

    return <div className="live-targets">{streamTo}</div>
  }
}

function FacebookStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a
        href="https://www.facebook.com/live/create"
        target="_blank"
        rel="noreferrer"
      >
        Facebook
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function YouTubeStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a
        href="https://www.youtube.com/live_dashboard"
        target="_blank"
        rel="noreferrer"
      >
        YouTube
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function PeriscopeStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a
        href="https://www.periscope.tv/account/producer"
        target="_blank"
        rel="noreferrer"
      >
        Periscope
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function VkontakteStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a href="https://vk.com/video" target="_blank" rel="noreferrer">
        Vkontakte
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function OdnoklassnikiStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a href="https://ok.ru/video/editor" target="_blank" rel="noreferrer">
        Odnoklassniki
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function TVUStreamHelp({ strings }) {
  return (
    <div className="stream__help">
      {strings['page.lives.view.add_stream.help.text_1']}
      <a href="https://www.youtube.com/live_dashboard" target="_blank">
        TVU
      </a>{' '}
      {strings['page.lives.view.add_stream.help.text_2']}
    </div>
  )
}

function FacebookManual(props) {
  return (
    <Spoiler
      title={props.strings['page.lives.view.add_stream.fb_manual.title']}
      className="stream-manual"
      headClassName="stream-manual__head"
      bodyClassName="stream-manual-body"
    >
      <ol className="stream-manual-list">
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.fb_manual.text_1']}
          <a
            href="https://www.facebook.com/live/create"
            target="_blank"
            rel="noreferrer"
          >
            facebook.com/live/create
          </a>
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.fb_manual.text_2']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.fb_manual.text_3']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.fb_manual.text_4']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.fb_manual.text_5']}
        </li>
      </ol>
      <div className="stream__help">
        {props.strings['page.lives.view.add_stream.fb_manual.text_6']}
        <a
          href="https://www.facebook.com/help/587160588142067"
          target="_blank"
          rel="noreferrer"
        >
          {props.strings['page.lives.view.add_stream.fb_manual.text_7']}
        </a>{' '}
        {props.strings['page.lives.view.add_stream.fb_manual.text_8']}
      </div>
    </Spoiler>
  )
}

function YouTubeManual(props) {
  return (
    <Spoiler
      title={props.strings['page.lives.view.add_stream.yt_manual.title']}
      className="stream-manual"
      headClassName="stream-manual__head"
      bodyClassName="stream-manual-body"
    >
      <ol className="stream-manual-list">
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_1']}
          <a
            href="https://www.youtube.com/live_dashboard"
            target="_blank"
            rel="noreferrer"
          >
            youtube.com/live_dashboard
          </a>{' '}
          {props.strings['page.lives.view.add_stream.yt_manual.text_2']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_3']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_4']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_5']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_6']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_7']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_8']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_9']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.yt_manual.text_10']}
          <a
            href="https://www.youtube.com/live_dashboard"
            target="_blank"
            rel="noreferrer"
          >
            youtube.com/live_dashboard
          </a>{' '}
          {props.strings['page.lives.view.add_stream.yt_manual.text_11']}
        </li>
      </ol>
      <div className="stream__help">
        {props.strings['page.lives.view.add_stream.yt_manual.text_12']}
        <a
          href="https://support.google.com/youtube/answer/2853700"
          target="_blank"
          rel="noreferrer"
        >
          {props.strings['page.lives.view.add_stream.yt_manual.text_13']}
        </a>{' '}
        {props.strings['page.lives.view.add_stream.yt_manual.text_14']}
      </div>
    </Spoiler>
  )
}

function PeriscopeManual(props) {
  return (
    <Spoiler
      title={props.strings['page.lives.view.add_stream.psc_manual.title']}
      className="stream-manual"
      headClassName="stream-manual__head"
      bodyClassName="stream-manual-body"
    >
      <ol className="stream-manual-list">
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.psc_manual.text_1']}
          <a
            href="https://www.periscope.tv/account/producer"
            target="_blank"
            rel="noreferrer"
          >
            www.periscope.tv/account/producer
          </a>
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.psc_manual.text_2']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.psc_manual.text_3']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.psc_manual.text_4']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.psc_manual.text_5']}
        </li>
      </ol>
      <div className="stream__help">
        {props.strings['page.lives.view.add_stream.psc_manual.text_6']}
        <a
          href="https://help.pscp.tv/customer/en/portal/articles/2600293-what-is-periscope-producer-?b_id=16119"
          target="_blank"
          rel="noreferrer"
        >
          {props.strings['page.lives.view.add_stream.psc_manual.text_7']}
        </a>{' '}
        {props.strings['page.lives.view.add_stream.psc_manual.text_8']}
      </div>
    </Spoiler>
  )
}

function OdnoklassnikiManual(props) {
  return (
    <Spoiler
      title={props.strings['page.lives.view.add_stream.ok_manual.title']}
      className="stream-manual"
      headClassName="stream-manual__head"
      bodyClassName="stream-manual-body"
    >
      <ol className="stream-manual-list">
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.ok_manual.text_1']}{' '}
          <a href="https://ok.ru/video/editor" target="_blank" rel="noreferrer">
            www.ok.ru/video/editor
          </a>
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.ok_manual.text_2']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.ok_manual.text_3']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.ok_manual.text_4']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.ok_manual.text_5']}
        </li>
      </ol>
      <div className="stream__help">
        {props.strings['page.lives.view.add_stream.ok_manual.text_6']}
        <a
          href="https://ok.ru/help/54/57/4682/FQ"
          target="_blank"
          rel="noreferrer"
        >
          {props.strings['page.lives.view.add_stream.ok_manual.text_7']}
        </a>{' '}
        {props.strings['page.lives.view.add_stream.ok_manual.text_8']}
      </div>
    </Spoiler>
  )
}

function VkontakteManual(props) {
  return (
    <Spoiler
      title={props.strings['page.lives.view.add_stream.vk_manual.title']}
      className="stream-manual"
      headClassName="stream-manual__head"
      bodyClassName="stream-manual-body"
    >
      <ol className="stream-manual-list">
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_1']}
          <a href="https://www.vk.com/video" target="_blank" rel="noreferrer">
            vk.com/video
          </a>{' '}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_2']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_3']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_4']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_5']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_6']}
        </li>
        <li className="stream-manual-item">
          {props.strings['page.lives.view.add_stream.vk_manual.text_7']}
        </li>
      </ol>
      <div className="stream__help">
        {props.strings['page.lives.view.add_stream.vk_manual.text_8']}
        <a
          href=" https://vk.com/faq13436?q=live"
          target="_blank"
          rel="noreferrer"
        >
          {props.strings['page.lives.view.add_stream.vk_manual.text_9']}
        </a>{' '}
        {props.strings['page.lives.view.add_stream.vk_manual.text_10']}
      </div>
    </Spoiler>
  )
}

function TVUManual(props) {
  return (
    <Fragment>
      <Spoiler
        title={props.strings['page.lives.view.add_stream.tvu_manual.title_2']}
        className="stream-manual"
        headClassName="stream-manual__head"
        bodyClassName="stream-manual-body"
      >
        <ol className="stream-manual-list">
          {props.languages.map((lang, i) => {
            if (!lang.stream_name.includes('Ch0')) {
              return (
                <li className="stream-manual-item" key={i}>
                  {lang.stream_name.slice(5)}: {lang.name}
                </li>
              )
            }
          })}
        </ol>
      </Spoiler>
      <Spoiler
        title={props.strings['page.lives.view.add_stream.tvu_manual.title_1']}
        className="stream-manual"
        headClassName="stream-manual__head"
        bodyClassName="stream-manual-body"
      >
        <ol className="stream-manual-list">
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_1']}
          </li>
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_2']}
          </li>
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_3']}
          </li>
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_4']}
          </li>
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_5']}
            <a href="https://tvunetworks.com" target="_blank">
              https://cc.tvunetworks.com
            </a>{' '}
          </li>
          <li className="stream-manual-item">
            {props.strings['page.lives.view.add_stream.tvu_manual.text_6']}
          </li>
        </ol>
      </Spoiler>
    </Fragment>
  )
}

export default DI(['targets'])(LiveTargets)
